import _objectSpread from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectSpread";
import DataActions from '../../../data/actions';
export var addMissingParts = function addMissingParts(option) {
  /**@type {import("data/types").DataGridContextMenuItemEntry<TDataModel>} */
  var item = {
    label: '',
    type: 'custom',
    hidden: false
  };

  if (typeof option === 'string') {
    item.type = option;
  } else {
    if (option) {
      item = _objectSpread({}, item, option);
    }
  }

  if (item.type === 'delete') {
    if (!item.label) item.label = 'Delete';
    if (!item.key) item.key = 'del';
  } else if (item.type === 'edit') {
    if (!item.label) item.label = 'Edit';
    if (!item.key) item.key = 'ctrl+e';
  } else if (item.type === 'properties') {
    if (!item.label) item.label = 'Properties';
    if (!item.key) item.key = 'alt+enter';
  } else if (item.type === 'rename') {
    if (!item.label) item.label = 'Rename';
    if (!item.key) item.key = 'f2';
  } else if (item.type === 'open') {
    if (!item.label) item.label = 'Open';
    if (!item.key) item.key = 'enter';
  }

  if (item.key && !item.keyCommand) {
    item.keyCommand = '';
    if (item.id) item.keyCommand += item.id;
    if (item.type) item.keyCommand += item.type;
    if (!item.keyCommand) item.keyCommand = item.label;
    if (!item.keyCommand) item.keyCommand = item.key;
    item.keyCommand = 'CMD_' + item.keyCommand.toUpperCase();
  }

  return item;
};
/**
 *
 * @param {import("data/types").DataGridContextMenuItem<TDataModel>} option
 * @param {any} item Data item
 * @param {any} config Data type config
 * @returns {import("data/types").DataGridContextMenuItemEntry<TDataModel>}
 */

var create = function create(option, dataItem, config) {
  var item = addMissingParts(option);
  if (typeof item.hidden === 'function') item.hidden = item.hidden(dataItem, config);

  var getModalProps = function getModalProps(dataItem) {
    var modalProps = {};

    if (item.modalProps) {
      modalProps = item.modalProps;
      if (typeof modalProps === 'function') modalProps = modalProps(dataItem, config);
    }

    return modalProps;
  };

  if (item.type === 'delete') {
    if (!item.onClick) {
      item.onClick = function (e, dataItem, grid) {
        var itemIdentifier = {
          id: dataItem[grid.idKeyProp],
          dataType: grid.dataType,
          dataProps: grid.dataProps
        };
        var DataApi = DataActions.item(itemIdentifier);
        DataApi.delete({
          useConfirmation: true,
          modalProps: getModalProps(dataItem)
        });
      };
    }
  } // else if (item.type === 'edit') {
  // }
  // else if (item.type === 'properties') {
  // }
  else if (item.type === 'rename') {
      if (!item.onClick) {
        item.onClick = function (e, dataItem, grid) {
          var itemIdentifier = {
            id: dataItem[grid.idKeyProp],
            dataType: grid.dataType,
            dataProps: grid.dataProps
          };
          var DataApi = DataActions.item(itemIdentifier);
          DataApi.rename({
            modalProps: getModalProps(dataItem),
            item: dataItem
          });
        };
      }
    } // else if (item.type === 'open') {
  // }


  return item;
};

export default create;